module.exports = __webpack_public_path__ + "static/media/phone.6e05d465.png";